import { connect } from "react-redux"

import Actions from "../../Actions/Creators"
import CovidStats from "./Component/CovidStats"

const mapStateToProps = (state, ownProps) => {
    return {
        organization: state.organization.currentOrganization || {},

        covidGlobalDashboard: state.organization.covidGlobalDashboard || {},
        covidDeclarationSymptoms: state.organization.covidDeclarationSymptomsV2 || {},
        covidGoogleRSSFeed: state.organization.covidGoogleRSSFeed || [],
        covidGoogleRSSFeedImages: state.organization.covidGoogleRSSFeedImages || []
    }
}

const mapDispatchToProps = (dispatch) => ({
    getCovidGlobalDashboard: (state, city) => dispatch(Actions.getCovidGlobalDashboard(state, city)),
    getCovidGlobalSymptoms: (state, city) => dispatch(Actions.getCovidDeclarationOverallSymptomsV2(state, city)),

    getCovidGoogleRSSFeed: (limit, start) => dispatch(Actions.getCovidGoogleRSSFeed(limit, start)),

    toggleUserProfileModal: (flag,modalType) => dispatch(Actions.changeUserProfileModalState(flag,modalType)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CovidStats)
